import QuerySelector from "../decorators/query-selector"
import OnEvent from "../decorators/on-event"

const SAVED_CLASS: string = 'saved'

export default class SavedState {

    @QuerySelector('[editable-heading]')
    private editableHeading: HTMLDivElement

    @OnEvent({
        selector: 'body',
        eventNames: [ 'nameSaved' ]
    })
    private nameChanged(): void {
        this.editableHeading.classList.add(SAVED_CLASS)

        setTimeout(() => this.editableHeading.classList.remove(SAVED_CLASS), 1500)
    }

    public static nameSaved(): void {
        document.querySelector('body').dispatchEvent(new CustomEvent('nameSaved'))
    }
}